import { type Filter, type InBoardFilter, type PostContainsFilter, Resource } from './constants';

export const isFilterBoardURLName = (filter: Filter): filter is InBoardFilter =>
  filter.resource === Resource.postBoardURLName;

export const isFilterPostContent = (filter: Filter): filter is PostContainsFilter =>
  filter.resource === Resource.postContent;
